import { ConfigurableProduct } from '@magentoTypes'

type MatchUrlToForm = {
  formCode: number
  product: ConfigurableProduct
}
export const matchUrlToForm = ({ product, formCode }: MatchUrlToForm) => {
  const filtered =
    product?.benuta_form_new == formCode
      ? product
      : product?.related_products?.find((item) => item?.benuta_form_new === formCode)
  return filtered?.url_key
}
